import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _typeof from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/typeof";
import "core-js/modules/es6.regexp.replace";
import Dialog from 'quasar/src/plugins/Dialog.js';import Loading from 'quasar/src/plugins/Loading.js';;

var escapeHtml = function escapeHtml(str) {
  return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
};

var showErrorMessage = function showErrorMessage(errorMessage) {
  var message = "Oops something went wrong!";

  if (errorMessage !== null && errorMessage !== undefined) {
    message = escapeHtml(errorMessage);
  }

  Loading.hide();
  Dialog.create({
    title: "Error",
    message: message,
    html: true
  });
};

var showErrorMessageFromServer = function showErrorMessageFromServer(errorMessage) {
  var message = "Oops something went wrong!";

  if (errorMessage && errorMessage.errors && _typeof(errorMessage.errors) === "object") {
    var itemArray = Object.keys(errorMessage.errors).map(function (item) {
      var rawMessages = Array.isArray(errorMessage.errors[item]) ? errorMessage.errors[item] : [errorMessage.errors[item]];
      var errorMessages = rawMessages.map(function (error) {
        return "\u2022 ".concat(escapeHtml(error), "<br>");
      }).join("");
      return "".concat(escapeHtml(item.charAt(0).toUpperCase() + item.slice(1)), ":<br><span class=\"color-error\">").concat(errorMessages, "</span>");
    });
    message = "<p>".concat(itemArray.join("<br>"), "</p>");
  } else if (errorMessage && typeof errorMessage.message === "string") {
    message = escapeHtml(errorMessage.message);
  } else if (typeof errorMessage === "string") {
    message = escapeHtml(errorMessage);
  }

  Loading.hide();
  Dialog.create({
    title: "Error",
    message: message,
    html: true
  });
};

export default {
  showErrorMessage: showErrorMessage,
  showErrorMessageFromServer: showErrorMessageFromServer
};